import React from "react";

let location =  <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-map-pin"
                              width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor"
                              fill="none" strokeLinecap="round" strokeLinejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
  <path d="M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"></path>
  <path d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z"></path>
</svg>;

let lock = <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-lock" width="12"
                    height="12" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor"
                     fill="none" strokeLinecap="round" strokeLinejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
  <path d="M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6z"></path>
  <path d="M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"></path>
  <path d="M8 11v-4a4 4 0 1 1 8 0v4"></path>
</svg>

let tag = <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-tag"
                         width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor"
                         fill="none" strokeLinecap="round" strokeLinejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
  <circle cx="8.5" cy="8.5" r="1" fill="currentColor"></circle>
  <path
    d="M4 7v3.859c0 .537 .213 1.052 .593 1.432l8.116 8.116a2.025 2.025 0 0 0 2.864 0l4.834 -4.834a2.025 2.025 0 0 0 0 -2.864l-8.117 -8.116a2.025 2.025 0 0 0 -1.431 -.593h-3.859a3 3 0 0 0 -3 3z"></path>
</svg>

let calendar = <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-calendar-event"
                              width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none"
                              strokeLinecap="round" strokeLinejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
  <path d="M4 5m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"></path>
  <path d="M16 3l0 4"></path>
  <path d="M8 3l0 4"></path>
  <path d="M4 11l16 0"></path>
  <path d="M8 15h2v2h-2z"></path>
</svg>

let users = <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-users" width="24"
                           height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none"
                           strokeLinecap="round" strokeLinejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
  <path d="M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"></path>
  <path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path>
  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
  <path d="M21 21v-2a4 4 0 0 0 -3 -3.85"></path>
</svg>

let trash = <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-users" width="16"
                           height="16" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none"
                           strokeLinecap="round" strokeLinejoin="round">
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M4 7l16 0"></path>
    <path d="M10 11l0 6"></path>
    <path d="M14 11l0 6"></path>
    <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path>
    <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>
  </svg>

let search = <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-users" width="16"
                           height="16" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none"
                           strokeLinecap="round" strokeLinejoin="round">
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"></path>
    <path d="M21 21l-6 -6"></path>
</svg>

let ghost = <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-users" width="16"
                           height="16" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none"
                           strokeLinecap="round" strokeLinejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
  <path
    d="M5 11a7 7 0 0 1 14 0v7a1.78 1.78 0 0 1 -3.1 1.4a1.65 1.65 0 0 0 -2.6 0a1.65 1.65 0 0 1 -2.6 0a1.65 1.65 0 0 0 -2.6 0a1.78 1.78 0 0 1 -3.1 -1.4v-7"></path>
  <path d="M10 10l.01 0"></path>
  <path d="M14 10l.01 0"></path>
  <path d="M10 14a3.5 3.5 0 0 0 4 0"></path>
  </svg>

let vswitch = <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-users" width="16"
                           height="16" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none"
                           strokeLinecap="round" strokeLinejoin="round">
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M3 8l4 -4l4 4"></path>
    <path d="M7 4l0 9"></path>
    <path d="M13 16l4 4l4 -4"></path>
    <path d="M17 10l0 10"></path>
  </svg>

export default {
  tag, location, calendar, users, trash, lock, search, ghost, vswitch
}